var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2458 9.29079C17.0584 9.10454 16.805 9 16.5408 9C16.2766 9 16.0232 9.10454 15.8358 9.29079L12.2458 12.8308L8.7058 9.29079C8.51844 9.10454 8.26498 9 8.0008 9C7.73661 9 7.48316 9.10454 7.2958 9.29079C7.20207 9.38376 7.12768 9.49436 7.07691 9.61622C7.02614 9.73807 7 9.86878 7 10.0008C7 10.1328 7.02614 10.2635 7.07691 10.3854C7.12768 10.5072 7.20207 10.6178 7.2958 10.7108L11.5358 14.9508C11.6288 15.0445 11.7394 15.1189 11.8612 15.1697C11.9831 15.2205 12.1138 15.2466 12.2458 15.2466C12.3778 15.2466 12.5085 15.2205 12.6304 15.1697C12.7522 15.1189 12.8628 15.0445 12.9558 14.9508L17.2458 10.7108C17.3395 10.6178 17.4139 10.5072 17.4647 10.3854C17.5155 10.2635 17.5416 10.1328 17.5416 10.0008C17.5416 9.86878 17.5155 9.73807 17.4647 9.61622C17.4139 9.49436 17.3395 9.38376 17.2458 9.29079Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.f9b91a3782d963a8d8c1933ffa4adbfe.svg";
export { ForwardRef as ReactComponent };